import React, { Component } from "react";
import { connect } from "react-redux";
import $ from "jquery";

import { Translate, I18n } from "react-redux-i18n";

import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

import "../../../styles/components/chargers/modals/AddPurchaseTariff.scss";
import { ReactComponent as DownloadIcon } from "../../../styles/images/download.svg";

class PurchaseTariffModal extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      validated: false,
      tariffType: "",
    };

    this.handleOnChangeTariffType = this.handleOnChangeTariffType.bind(this);
    this.handleOnChangeBillingType = this.handleOnChangeBillingType.bind(this);
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
    this.resetState = this.resetState.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.selectedTariff &&
      prevProps?.selectedTariff?.tariffType !== this.props.selectedTariff.tariffType
    ) {
      this.safeSetState({
        tariffType: this.props.selectedTariff.tariffType,
      });
    }
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  handleOnSubmit(e) {
    e.preventDefault();
    const form = $(e.target)[0];
    this.safeSetState({ validated: true }, () => {
      if (form.checkValidity() !== false) {
        this.props.onSubmit(form);
      }
    });
  }

  handleOnChangeTariffType(e) {
    this.safeSetState({
      tariffType: e.target.value,
    });
  }

  handleOnChangeBillingType(e) {
    this.safeSetState({
      billingType: e.target.value,
    });
  }

  resetState() {
    this.safeSetState({
      validated: false,
      tariffType: "",
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <Modal
        id="addPurchaseTariff"
        show={this.props.show}
        onHide={this.props.onHide}
        onExited={this.resetState}
        centered
      >
        <Modal.Header>
          <Modal.Title>
            <Translate
              value={`purchaseTariffs_${
                this.props.mode === "add"
                  ? "addTariff"
                  : this.props.mode === "edit"
                  ? "editTariff"
                  : "import"
              }`}
            />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.props.mode === "import" && (
            <a
              href={`https://${
                process.env.REACT_APP_BUILD_MODE === "production" ? "" : "pre-"
              }filesapi.go-evio.com/template/cost_tariff_template.xlsx`}
              className="template-link"
            >
              <div className="evio-tariff-template-tip">
                <div className="i-icon">i</div>
                <Translate value="purchaseTariffs_importFileTip" />
                <DownloadIcon />
              </div>
            </a>
          )}
          <Form
            id="add-purchase-tariff"
            noValidate
            validated={this.state.validated}
            onSubmit={this.handleOnSubmit}
          >
            <Form.Group className="form-field" controlId="purchaseTariffName">
              <Form.Label>
                <Translate value="addPurchaseTariff_name" />
              </Form.Label>
              <Form.Control
                type="text"
                name="tariffName"
                placeholder={I18n.t("addTariff_tariffNameExample")}
                defaultValue={this.props.selectedTariff?.name}
                required
              />
              <Form.Control.Feedback type="invalid">
                <Translate value="addPurchaseTariff_invalidTariffName" />
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="form-field" controlId="purchaseTariffType">
              <Form.Label>
                <Translate value="addPurchaseTariff_tariffType" />
              </Form.Label>
              <div className="select">
                <Form.Control
                  as="select"
                  name="tariffType"
                  value={this.state.tariffType}
                  onChange={this.handleOnChangeTariffType}
                  required
                >
                  <option value="" disabled hidden>
                    {I18n.t("addTariff_tariffTypeSelect")}
                  </option>
                  <option value="Time Based">{I18n.t("addTariff_timeBased")}</option>
                  <option value="Energy Based">{I18n.t("addTariff_energyBased")}</option>
                </Form.Control>
              </div>
            </Form.Group>
            <Form.Group className="form-field" controlId="purchaseTariffDescription">
              <Form.Label>
                <Translate value="addPurchaseTariff_description" />
              </Form.Label>
              <Form.Control
                as="textarea"
                name="tariffDescription"
                placeholder={I18n.t("addPurchaseTariff_typeHere")}
                defaultValue={this.props.selectedTariff?.description}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <button type="submit" form="add-purchase-tariff">
            <Translate
              value={
                this.props.mode === "add"
                  ? "addTariff_add"
                  : this.props.mode === "edit"
                  ? "addTariff_edit"
                  : "general_import"
              }
            />
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  locale: state.i18n.locale,
  preferences: state.account.preferences,
  userPackage: state.account.accountData.userPackage,
  isAdmin: state.account.isAdmin,
});

export default connect(mapStateToProps, null)(PurchaseTariffModal);
